/**
 * 一覧取得系APIで1度に取得できる最大件数
 * @note マスタデータ系(ex:Department, Position, etc.)のfetch系API以外では使用しないこと
 *
 * ### 背景
 * マスタデータ系画面ではそもそも総レコード数が少ないため、
 * ページネーションを利用せずに1度に全件表示する。
 * 2000という数字はAPIで制限されている最大値を元に設定。
 */
export const MAX_PAGE_SIZE = 2000;